// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let Answer
import { getAPIURL } from "assessments/utils"

export default Answer = (function () {
  Answer = class Answer extends (
    require("lib/static-shim").default(require("lib/utils/model").default)
  ) {
    static initClass() {
      this.prototype.defaults = { is_answered: false }
    }

    url() {
      let url = `${this.get("assessment")}/question/${this.question.id}/answer`
      if (this.id != null) {
        url = `${url}/${this.id}`
      }

      // TODO: remove once legacy path UI is gone
      const acontext = window.App.request("get:assessment:context")
      return getAPIURL(url, this, acontext)
    }

    validate() {
      const attrs = this.attributes
      if (attrs.skipValidation) {
        return
      }

      this.errors = this.question.validateAnswer(this)
      if (this.errors.length) {
        return this.errors
      }
    }

    hasAnswerExplanation() {
      return this.get("wrong_answer_tip")
    }
  }
  Answer.initClass()
  return Answer
})()
